export const editElement = (element) => {
  return (dispatch) => {
    dispatch({ type: 'EDIT_ELEMENT', element });
  };
};

export const changeDevice = (device) => {
  return (dispatch) => {
    dispatch({ type: 'SET_DEVICE', device: device });
  };
};

export const copyIt = (layout) => {
  return (dispatch) => {
    dispatch({ type: 'COPY', toCopy: layout });
  };
};

export const copyBlock = (block) => {
  return (dispatch) => {
    dispatch({ type: 'COPY_BLOCK', blockToCopy: block });
  };
};

export const setShowBlockSettings = (show) => {
  return (dispatch) => {
    dispatch({ type: 'SHOW_BLOCK_SETTINGS', showBlockSettings: show });
  };
};
export const setGlobalList = (show) => {
  return (dispatch) => {
    dispatch({ type: 'SET_SHOW_GLOBALE_LIST', show });
  };
};
